import RingDialog from '@jetbrains/ring-ui/components/dialog-ng/dialog-ng';
import CleanBackupDialog from './manage-old-upgrade.html';

const CREATE_BACKUP = 'create-backup';

class ManageOldUpgrade {
  /*@ngInject*/
  constructor($q, installerResource, dialog, wizardInfo) {
    this.$q = $q;
    this.installerResource = installerResource;
    this.dialog = dialog;
    this.wizardInfo = wizardInfo;
  }

  manageExistUpgrade(isGoingToCleanInstallation) {

    const cleanBackupButtonAction = backupBeforeRemove => this.cleanExistBackup(backupBeforeRemove).
      then(() => {
        // Remove license settings potentially initialized from discarded upgrade source
        this.installerResource.clearSingletonOf('licenseSettings');
      }).
      catch(err => {
        const error = this.installerResource.extractErrorMessage(err.data);
        const errorMessage = error.sourceLocation ? error.sourceLocation.error_description : error; // jshint ignore:line
        throw errorMessage;
      });

    return this.installerResource.upgradeSourceClean.get().$promise.
      then(res => this.dialog.show({
        title: 'Create Backup of Settings from Previous Installation',
        data: {backupPath: res.backupPath, productName: this.wizardInfo.productName, isGoingToCleanInstallation},
        wideDialog: true,
        template: CleanBackupDialog,
        buttons: [{
          label: 'Create backup',
          default: true,
          action: () => CREATE_BACKUP
        }, {
          label: 'Cancel',
          close: true
        }]
      }).
        then(action => {
          if (action === CREATE_BACKUP) {
            return cleanBackupButtonAction(true);
          }
          return this.$q.reject();
        }));
  }

  cleanExistBackup(backupBeforeRemove = true) {
    return this.installerResource.upgradeSourceClean.save({backup: backupBeforeRemove}).$promise;
  }
}

const oldUpgradeModule = angular.module('ring.installer.manage-old-upgrade', [RingDialog]).
  service('oldUpgradeManager', ManageOldUpgrade);

export default oldUpgradeModule.name;



// WEBPACK FOOTER //
// ./src/blocks/manage-old-upgrade/manage-old-upgrade.js